import { useState, useEffect } from "react";
import { Modal } from "semantic-ui-react";
import { RegisterForm, LoginForm } from "../../../components/Admin/Auth";
import "./Auth.scss";
import { useLanguage } from "../../../contexts";
import { EcosystemPanel } from "./EcosystemPanel";
import { BrujulaPanel } from "./BrujulaPanel";
import { EcosystemMobileHeader } from "./EcosystemMobileHeader";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { SocialLinks } from "./SocialLinks";
import logoInk from "../../../assets/png/brand/logo-ink.png";

export function Auth() {
  const [registerOpen, setRegisterOpen] = useState(false);
  // Se elige una de las dos direcciones visuales del panel derecho al azar,
  // una vez por carga — mismo patrón que mern-consultora.
  const [rightVariant] = useState(() => (Math.random() < 0.5 ? "ecosystem" : "brujula"));

  const { changeLanguage, translations } = useLanguage();
  const t = (key) => translations[key] || key;

  useEffect(() => {
    // Solo auto-detectar en la primera visita — si el usuario ya eligió un
    // idioma antes (o lo cambió manualmente), no lo pisamos en cada login.
    if (localStorage.getItem("appLanguage")) return;
    const idiomaNavegador = navigator.language || navigator.userLanguage;
    const idioma = idiomaNavegador.split("-")[0];
    if (["es", "en", "pt", "fr"].includes(idioma)) {
      changeLanguage(idioma);
    } else {
      changeLanguage("es");
    }
  }, []);

  return (
    <div className="login-page">
      <EcosystemMobileHeader t={t} />

      <div className="login-page__form-panel">
        <img src={logoInk} alt="sustemia" className="login-page__logo" />

        <div className="login-page__center">
          <span className="login-page__kicker">{t("login_kicker")}</span>
          <h1 className="login-page__title">
            {t("login_title_line1")}
            <br />
            {t("login_title_line2_pre")}{" "}
            <span className="login-page__title-highlight">{t("login_title_highlight")}</span>.
          </h1>
          <p className="login-page__subtitle">{t("login_subtitle")}</p>

          <div className="login-page__form-wrap">
            <LoginForm />
            <div className="login-page__register">
              {t("login_no_account")}{" "}
              <a
                href="#registro"
                onClick={(e) => {
                  e.preventDefault();
                  setRegisterOpen(true);
                }}
              >
                {t("register")}
              </a>
            </div>
          </div>
        </div>

        <div className="login-page__footer">
          <span className="login-page__footer-tag">{t("login_footer_tag")}</span>
          <SocialLinks />
          <LanguageSwitcher />
        </div>
      </div>

      <div className="login-page__eco-panel">
        {rightVariant === "ecosystem" ? <EcosystemPanel t={t} /> : <BrujulaPanel t={t} />}
      </div>

      {/* Registro sigue como modal, sin cambios de lógica */}
      <Modal
        open={registerOpen}
        onClose={() => setRegisterOpen(false)}
        size="tiny"
        closeIcon
        className="auth-modal"
      >
        <Modal.Content>
          <RegisterForm openLogin={() => setRegisterOpen(false)} />
        </Modal.Content>
      </Modal>
    </div>
  );
}
